module.exports = __webpack_public_path__ + "img/icon_gaojing.76d6a95a.png";